export const getDataResult = function ($, url, type, param) {
  return new Promise(function (resolve, reject) {
    const formData = new FormData();
    Object.keys(param).forEach((key) => {
      formData.append(key, param[key]);
    });
    $.ajax({
      url: `https://fun.guangxifxj.cn${url}`,
      type: type,
      data: param,
      success: function (res) {
        resolve(JSON.parse(res));
      },
      error: function (error) {
        reject(error);
      }
    });
  });
}

export const serviceGetShareSignature = function ($, title, desc, imgUrl, link) {
  $.ajax({
    type: 'GET',
    url: 'https://zuul.gxrb.com.cn/api-newtime/getSignature/GetSignature/?shareurl=' + encodeURIComponent(window.location.href),
    success: function (t) {
      var e = {
        title: title, // 标题
        desc: desc, // 描述
        imgUrl: imgUrl,
        link: link,
      };
      t.data && t.data.noncestr && (wx.config({
        debug: !1,
        appId: 'wxd9cd53936e29779d',
        timestamp: t.data.timestamp,
        nonceStr: t.data.noncestr,
        signature: t.data.signature,
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'updateAppMessageShareData', 'openLocation', 'getLocation'],
        openTagList: ['wx-open-launch-weapp']
      }), wx.ready(function () {
        console.log('wx ready'), wx.onMenuShareAppMessage(e), wx.onMenuShareTimeline(e), wx.onMenuShareQQ(e), wx.onMenuShareWeibo(e), wx.onMenuShareQZone(e), wx.updateAppMessageShareData(e), wx.updateTimelineShareData(e);
      }));
    }
  });
}




// // 滚动数字东效
// export const show_num = function (n) {
//   var timer = null;
//   var number = Number(n);
//   var length = 32;
//   var arr = [];
//   var index = 0;
//   for (var i = length; i >= 2; i--) {
//     arr.push(Math.floor(number / i));
//   }
//   arr.push(number);
//   // 定时器开始滚动
//   timer = setInterval(function () {
//     if (index >= arr.length) {
//       clearInterval(timer);
//       return;
//     }
//     count.text(arr[index]);
//     index++
//   }, 20);
// }